import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form } from 'semantic-ui-react'

import SeguroPermite from '../../../components/funcionales/seguropermite'

import XLSX from 'xlsx'
import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries' 
var moment = require('moment');

class ProgDepurar2 extends React.Component {
  state={permiteUpdate: true, confirmaAct: false, open: false
  }

  handleSubmit = async (ev)=>{
    document.body.style.cursor = 'wait'
  
    let allLubricante = this.props.allLubricante.allLubricante

  // let fechaDesde = new Date()
  // let fechaHoy = moment(new Date()).format('YYYY-MM-DD')
  // fechaDesde = (fechaHoy.substring(0, 4) + '-01-01')
  // fechaDesde=moment(fechaDesde).format('YYYY-MM-DD')

let fechaDesde = moment().subtract(365, 'days').format('YYYY-MM-DD')
console.log(fechaDesde)
    // let fechaDesde = moment('2024-02-01').format('YYYY-MM-DD')
    let unidad = ""
    let argsBuscarEmp = {tipoqry: `[{$match: {rutas: 'S'}}]`}
  
    let {data} = await this.props.allEmpresaRtes.refetch(argsBuscarEmp)
    let empresas = await data.allEmpresaRtes
    let argsQuery = `{"$unwind": "$inventario"},
    {$project: {_id: '$inventario.fechaAct', descrLubricante: 1, 
        descrEmpresa: '$inventario.descrEmpresa', 
        existencia: '$inventario.existencia', 
        minimo: '$inventario.minimo',
        descrUnidad: '$inventario.descrUnidad', 
        usuarioAct: '$inventario.usuarioAct',
        fechaAct: '$inventario.fechaAct'}},
    {$sort: {descrLubricante: 1}}`
    let argsQuery1 = `{$project: {fechaProg: 1, descrEmpresa: 1, descrMetodo: 1, descrTarea: 1, estadoOrden: 1, realizado: 1}},
    {$group: {_id: {fechaProg: '$fechaProg', estadoOrden: '$estadoOrden', descrEmpresa: '$descrEmpresa', 
        descrMetodo: '$descrMetodo', descrTarea: '$descrTarea', realizado: '$realizado'}, count: { $sum: 1 }}},
       {$project: {_id: {$concat: [{"$toString": '$_id.fechaProg'}, '$_id.estadoOrden', '$_id.descrEmpresa', 
       '$_id.descrMetodo', '$_id.descrTarea', '$_id.realizado']}, fechaProg: '$_id.fechaProg', descrEmpresa: '$_id.descrEmpresa', descrMetodo: '$_id.descrMetodo',
       descrTarea: '$_id.descrTarea', estadoOrden: '$_id.estadoOrden', realizado: '$_id.realizado', acumReal: {$toInt: '$count'}}}`

    //Archivo Excel
    let xlsString = []
    let xlsString1 = []
    let xlsStringG = []
    let xlsString1G = []
    let campoAgno = '', campoMes = '', campoDia = '', agnoMes = '', fechaReal = '', fechaProg = '', agnoMesProg = '' 

    if(empresas.length>0){   
      xlsString1G = ['Fecha prog.', 'Estado OT', 'Empresa', 'Método', 'Tarea', 'Realizado', 'Cantidad']
      xlsStringG.push(xlsString1G)

      console.log(empresas.length)
      for(let i=0; i<empresas.length; i++){
        let logo=empresas[i].rutaLogo?empresas[i].rutaLogo:''
  
        let argsBuscarG=""
        argsBuscarG += `estadoOrden: {$in: ['Abierto', 'Cerrado']}, fechaProg: { $gte: new Date('2024-02-01')}, 'descrEmpresa': '${empresas[i].descrEmpresa}' `
        let estructuraG = []
        let argsBuscarO = {tipoqry: `[{$match: {${argsBuscarG}}}, ${argsQuery1}]`}

        // if(this.props.allOrdenRtesGroup){
          // console.log(argsBuscarO)
          let {data} = await this.props.allOrdenRtes.refetch(argsBuscarO)
          estructuraG = await data.allOrdenRtes
          console.log(estructuraG.length)
          let cont=0
          if(estructuraG.length>0){       
            for(let ii=0; ii<estructuraG.length; ii++){
// console.log(estructuraG[ii])
              cont=ii
              campoAgno = estructuraG[ii].fechaProg.substring(0, 4)
              campoMes = estructuraG[ii].fechaProg.substring(5, 7)
              campoDia = estructuraG[ii].fechaProg.substring(8, 10)
              fechaProg=campoAgno + '-' + campoMes + '-' + campoDia

              xlsString1G = [fechaProg, estructuraG[ii].estadoOrden, estructuraG[ii].descrEmpresa, 
              estructuraG[ii].descrMetodo, estructuraG[ii].descrTarea, estructuraG[ii].realizado, estructuraG[ii].acumReal]
// console.log(xlsString1G)
              xlsStringG.push(xlsString1G)
console.log(i, ii)

            }
          }
          if((cont===estructuraG.length-1 || estructuraG.length===0) && i===empresas.length-1){
            // console.log(xlsStringG)
            var wb = XLSX.utils.book_new();
            wb.Props = {
              Title: "SheetJS Tutorial",
              Subject: "Test",
              Author: "Red Stapler",
              CreatedDate: new Date(2017,12,19)
            };
            wb.SheetNames.push("Rutas");
            let ws_data = xlsStringG;

            let ws = XLSX.utils.aoa_to_sheet(ws_data);
            wb.Sheets["Rutas"] = ws;
            let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
            function s2ab(s) { 
              let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
              let view = new Uint8Array(buf);  //create uint8array as viewer
              for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
              return buf;    
            }
            saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'Rutas.xlsx');
  //FIN Exportar a XLS
          }
        // }
      }
    }

    xlsString1 = ['Ruta', 'OT', 'Estado OT', 'Fecha prog.', 'Empresa', 'Planta', 'Sección', 'Tarea', 'Tipo de hallazgo', 'Tipo lub.', 
      'Lubricante', 'Cant. prog', 'Und', 'Puntos', 'Min prog.', 'Realizado', 'Fecha real', 'Operario real', 'Cant. real', 'Min. real', 
      'Unidad', 'Cantidad de lubricante', 'Horas-Hombre', 'Cant. de hallazgos', 'Logo']
    
    xlsString.push(xlsString1)

    let descrEmpresa=''
    if(empresas.length>0){   
      for(let i=0; i<empresas.length; i++){
        // xlsString1 = ['Ruta', 'OT', 'Estado OT', 'Fecha prog.', 'Empresa', 'Planta', 'Sección', 'Equipo', 'Componente',
        // 'Mecanismo', 'Método', 'Tarea', 'Tipo de hallazgo', 'Tipo lub.', 'Lubricante', 'Cant. prog', 'Und', 'Puntos', 'Min prog.', 'Realizado', 'Fecha real', 'Hora real',
        // 'Cedula', 'Operario asig.', 'Cedula real', 'Operario real', 'Cant. real', 'Min. real', 'Unidad', 'Cantidad de lubricante', 'Horas-Hombre', 'Año', 'Mes', 'Año/mes ejec.', 'Año/mes prog.', 'Cant. de hallazgos', 'Logo']
       
        let rutaLogo=empresas[i].rutaLogo?empresas[i].rutaLogo:''
        descrEmpresa=empresas[i].descrEmpresa
        
        let argsBuscar=""
        argsBuscar += `'descrEmpresa': '${empresas[i].descrEmpresa}', fechaProg: { $gte: new Date('${fechaDesde}') }`
        let argsBuscarPl = {tipoqry: `[{$match: {${argsBuscar}}}]`}
        let {data} = await this.props.allOrdenRtes.refetch(argsBuscarPl)
        let estructura = await data.allOrdenRtes
        // console.log(estructura)

        if(estructura.length>0){       
          for(let ii=0; ii<estructura.length; ii++){
            console.log(estructura[ii])
            let indexLub = allLubricante.findIndex( lubricante => lubricante.descrLubricante===estructura[ii].descrLubricante.replace(/^\s+|\s+$/g, ''))
            if(allLubricante[indexLub].tipoLub==='Aceite'){
              unidad='Galones'
            }else{
              if(allLubricante[indexLub].tipoLub==='Grasa'){
                unidad='Kilogramos'
              }else{
                unidad='Unidad'
              }
            }
            let cantLub = estructura[ii].cantidadReal
            if(unidad==='Galones'){
              if(estructura[ii].descrUnidad==='Galón' || estructura[ii].descrUnidad==='Galon' || estructura[ii].descrUnidad==='galón' || estructura[ii].descrUnidad==='galon'){
              }else{
                switch(estructura[ii].descrUnidad){
                  case 'Litros':
                    cantLub=cantLub*0.264;
                    break
                  case 'Mililitro':
                    cantLub=cantLub*0.00264;
                    break
                  case 'Onza':
                    cantLub=cantLub*0.0078125;
                    break
                  case 'Gramos':
                    cantLub=cantLub/3657.14826;
                  break
                }
              }
            }else{
              if(unidad==='Kilogramos'){
                if(estructura[ii].descrUnidad==='Gramos' || estructura[ii].descrUnidad==='gramos'){
                  cantLub=cantLub/1000
                }else{
                  switch(estructura[ii].descrUnidad){
                    case 'Onza':
                      cantLub=cantLub*0.0283495;
                      break
                    case 'Libra':
                      cantLub=cantLub/2;
                      break
                    case 'Kilos':
                      break
                  }
                }
              }else{

              }
            }
  
            let cantidadHoras=estructura[ii].minutosReal/60

            let horaReal=estructura[ii].horaReal?estructura[ii].horaReal:0
            if(estructura[ii].fechaProg){
              campoAgno = estructura[ii].fechaProg.substring(0, 4)
              campoMes = estructura[ii].fechaProg.substring(5, 7)
              campoDia = estructura[ii].fechaProg.substring(8, 10)
              fechaProg=campoAgno + '-' + campoMes + '-' + campoDia
              agnoMesProg=campoAgno + '/' + campoMes

            }
            if(estructura[ii].fechaReal){
              campoAgno = estructura[ii].fechaReal.substring(0, 4)
              campoMes = estructura[ii].fechaReal.substring(5, 7)
              campoDia = estructura[ii].fechaReal.substring(8, 10)
              fechaReal=campoAgno + '-' + campoMes + '-' + campoDia
              agnoMes=campoAgno + '/' + campoMes
            }

            let cantHallazgo=0

            if(estructura[ii].descrMetodo==='Hallazgo' && estructura[ii].descrTarea!=='Tomar muestra'){
              cantHallazgo=1
            }

            cantLub=parseFloat(cantLub).toFixed(3)
            cantidadHoras=parseFloat(cantidadHoras).toFixed(3)
            // xlsString1 = [estructura[ii].ruta, estructura[ii].numeroOrden, estructura[ii].estadoOrden, fechaProg, estructura[ii].descrEmpresa, estructura[ii].descrPlanta,
            // estructura[ii].descrSeccion, estructura[ii].descrEquipo, estructura[ii].descrComponente, estructura[ii].descrMecanismo, 
            // estructura[ii].descrMetodo, estructura[ii].descrTarea, estructura[ii].descrHallazgo, allLubricante[indexLub].tipoLub, estructura[ii].descrLubricante, estructura[ii].cantidad, 
            // estructura[ii].descrUnidad, estructura[ii].puntosLub, estructura[ii].minutos, estructura[ii].realizado, fechaReal, horaReal,
            // estructura[ii].cedula, estructura[ii].nombreUsuario, estructura[ii].cedulaReal,
            // estructura[ii].nombreUsuarioReal, estructura[ii].cantidadReal, estructura[ii].minutosReal, 
            // unidad, cantLub, cantidadHoras, campoAgno, campoMes, agnoMes, agnoMesProg, cantHallazgo, logo]

            cantidadHoras=parseFloat(cantidadHoras).toFixed(3)
            xlsString1 = [estructura[ii].ruta, estructura[ii].numeroOrden, estructura[ii].estadoOrden, fechaProg, estructura[ii].descrEmpresa, estructura[ii].descrPlanta,
            estructura[ii].descrSeccion, estructura[ii].descrTarea, estructura[ii].descrHallazgo, allLubricante[indexLub].tipoLub, 
            estructura[ii].descrLubricante, estructura[ii].cantidad, 
            estructura[ii].descrUnidad, estructura[ii].puntosLub, estructura[ii].minutos, estructura[ii].realizado, fechaReal, 
            estructura[ii].nombreUsuarioReal, estructura[ii].cantidadReal, estructura[ii].minutosReal, 
            unidad, cantLub, cantidadHoras, cantHallazgo, rutaLogo]

            xlsString.push(xlsString1)

            if(ii===estructura.length-1){
              argsBuscar = `'descrEmpresa': '${empresas[i].descrEmpresa}'`
              let argsBuscarEx = {tipoqry: `[${argsQuery}, {$match: {${argsBuscar}}}]`}
              let {data} = await this.props.allLubricanteRtes.refetch(argsBuscarEx)
              let existencias = await data.allLubricanteRtes
        
              if(existencias.length>0){
                existencias.forEach(async (elemento, _id) => {
                  let tipoLub=''
                  let indexLubE = allLubricante.findIndex( lubricante => lubricante.descrLubricante===elemento.descrLubricante.replace(/^\s+|\s+$/g, ''))
                  if(indexLubE===-1){
                  }else{
                    tipoLub=allLubricante[indexLubE].tipoLub
                  }
                  xlsString1 = [0, 0, 'Existencias', '2024-02-01', estructura[ii].descrEmpresa, '', '', '', '', 
                  tipoLub, elemento.descrLubricante, elemento.existencia, elemento.descrUnidad, 0, 0, '', '2024-02-01', '',
                  0, 0, '', 0, 0, elemento.minimo?elemento.minimo:0, rutaLogo]

                  xlsString.push(xlsString1)

                })
              }
            // }

             
    //FIN Exportar a XLS
            }
          }
        }
        
      }
      var wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "SheetJS Tutorial",
        Subject: "Test",
        Author: "Red Stapler",
        CreatedDate: new Date(2017,12,19)
      };
      wb.SheetNames.push("Rutas");
      let ws_data = xlsString;

      let ws = XLSX.utils.aoa_to_sheet(ws_data);
      wb.Sheets["Rutas"] = ws;
      let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
      function s2ab(s) { 
        let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
        let view = new Uint8Array(buf);  //create uint8array as viewer
        for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
        return buf;    
      }
      saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'Rutas_Lubricacion.xlsx');

      xlsString = []
      xlsString1 = []
    }
    document.body.style.cursor = 'default'
  }




  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  render(){
    const {permiteUpdate, confirmaAct, open} = this.state;
    let mensaje = "Descargar matríz en Excel"
    let imgIcon = "images/documento_32.png"
let fechaDesd = moment().subtract(365, 'days').format('YYYY-MM-DD')
console.log(fechaDesd)
    return (
      <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
        <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev):()=>{}}>
          <div className="ui two column stackable grid">
            <div className="row container">
              <div className="column" style={{width: '30%', paddingTop: '0.1em'}}>
                <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
              </div>
            </div>
          </div>
        </Form>
      </div>
    )
  }
};

export default compose(
  graphql(queries.query.allOrdenRtes, {name:'allOrdenRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: ''}}]`}}}}),
  graphql(queries.query.allLubricante, {name:'allLubricante'}),
  graphql(queries.query.allLubricanteRtes, {name:'allLubricanteRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrLubricante: {$ne: 'Seleccionar...'}}}]`}}}}),  
  graphql(queries.query.allUnidad, {name:'allUnidad'}),
  graphql(queries.query.allFrecuencia, {name:'allFrecuencia'}),
  graphql(queries.query.allAplicacion, {name:'allAplicacion'}),
  graphql(queries.query.allUsuarios, {name:'allUsuarios'}),
  graphql(queries.query.allEmpresaRtes, {name:'allEmpresaRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: {$ne: 'Seleccionar Empresa...'}}}]`}}}}),
  graphql(queries.mutation.editEmpresa, {name:'editEmpresa'}),
  graphql(queries.mutation.editEmpresaMany, {name:'editEmpresaMany'}),
  graphql(queries.mutation.fecha, {name:'fecha'}),

)(ProgDepurar2)
